// State hub pages — rank for broader queries like "we buy houses california"
// State slugs are intentionally distinct from city slugs (city slugs include state abbr suffix like "-ca")

export const states = [
  {
    slug: 'michigan',
    name: 'Michigan',
    stateAbbr: 'MI',
    headline: 'We Buy Houses for Cash Across Michigan',
    metaTitle: 'We Buy Houses Michigan | Statewide Cash Home Buyers & Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Michigan house fast for cash — Detroit, Flint, Grand Rapids, Lansing, Warren, Sterling Heights, Dearborn. Investors: Michigan’s top off-market wholesale list. Not a brokerage.',
    intro:
      'Michigan is the #1 wholesaling state in America. With Detroit, Flint, and Grand Rapids leading the country in deal flow, the Great Lakes State combines low entry prices, strong rental demand, and landlord-friendly laws. We buy houses across Wayne, Oakland, Macomb, Genesee, Kent, Ingham, and Washtenaw counties — any condition, any price range, any timeline.',
    sellerCopy:
      'Whether your property is in a Detroit auction zip, a Flint cashflow neighborhood, or a Grand Rapids appreciating suburb — we make a cash offer in 24 hours. We handle delinquent taxes, code violations, tenant issues, probate, and out-of-state inheritance.',
    buyerCopy:
      'Michigan delivers the highest cashflow returns of any major US wholesaling state. Our buyer list gets first look at Detroit fix-and-flips, Flint BRRRR rentals, Grand Rapids appreciation plays, and small multi-family in Pontiac, Saginaw, and Bay City.',
    counties: ['Wayne', 'Oakland', 'Macomb', 'Genesee', 'Kent', 'Ingham', 'Washtenaw', 'Saginaw', 'Bay'],
    stats: [
      { label: 'Avg SFR price (Detroit)', value: '$70K' },
      { label: 'Avg rent (Detroit SFR)', value: '$1,100' },
      { label: 'Wholesaler deal volume (state)', value: '#1 USA' },
      { label: 'Counties served', value: '15+' },
    ],
    keywords: 'we buy houses michigan, michigan wholesale properties, michigan cash home buyers, sell my house fast michigan, michigan real estate investors, off-market deals michigan, BRRRR michigan, michigan fix and flip, distressed properties michigan',
    geo: { lat: 44.3148, lon: -85.6024 },
  },
  {
    slug: 'arizona',
    name: 'Arizona',
    stateAbbr: 'AZ',
    headline: 'We Buy Houses for Cash Across Arizona',
    metaTitle: 'We Buy Houses Arizona | AZ Cash Home Buyers & Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your Arizona house fast for cash — Phoenix, Tucson, Mesa, Glendale, Chandler. Investors: AZ wholesale buyer list with fix-and-flip and BRRRR opportunities. Not a brokerage.',
    intro:
      'Arizona is one of America’s top-3 wholesaling states by deal volume. Phoenix metro continues to attract migration from California and the Midwest, fueling appreciation, while Tucson offers California’s best cashflow with 40% lower entry prices than Phoenix. We buy across Maricopa and Pima counties — any condition.',
    sellerCopy:
      'Inherited a Sun City home? Out-of-state landlord exhausted by Phoenix property management? Pre-foreclosure in West Phoenix or South Tucson? We close in 7–21 days, all cash, no inspections.',
    buyerCopy:
      'Arizona wholesale deals: Phoenix SFR fix-and-flips $250K–$450K, Tucson BRRRR rentals $150K–$280K, infill teardowns in emerging Maricopa zips, and value-add multifamily near ASU and UA.',
    counties: ['Maricopa', 'Pima', 'Pinal', 'Yavapai', 'Mohave'],
    stats: [
      { label: 'Avg SFR price (Phoenix)', value: '$425K' },
      { label: 'Avg SFR price (Tucson)', value: '$295K' },
      { label: 'Population growth (last 5y)', value: '+11%' },
      { label: 'Counties served', value: '5+' },
    ],
    keywords: 'we buy houses arizona, arizona wholesale properties, arizona cash home buyers, sell my house fast arizona, phoenix wholesale, tucson wholesale, maricopa county cash buyers, az real estate investors',
    geo: { lat: 34.0489, lon: -111.0937 },
  },
  {
    slug: 'california',
    name: 'California',
    stateAbbr: 'CA',
    headline: 'We Buy Houses for Cash Across California',
    metaTitle: 'We Buy Houses California | CA Cash Home Buyers & Wholesale Deals | DreamHousesUSA',
    metaDescription: 'Sell your California house fast for cash — Los Angeles, Sacramento, Bakersfield, San Diego, Fresno. Investors: CA off-market wholesale deals with assignable contracts. Not a brokerage.',
    intro:
      'California is the highest-equity wholesaling state in America. Probate, divorce, and tired-landlord situations create steady deal flow in LA County, Sacramento, and Kern County. We buy across California — any condition, any neighborhood, all cash.',
    sellerCopy:
      'Probate property in South LA? Inherited a Compton duplex? Underwater Bakersfield rental? Tax-defaulted Sacramento home? We close fast, all cash, no contingencies, no agent commissions — and we navigate California’s tenant laws and Prop 19 transfer requirements.',
    buyerCopy:
      'California wholesale deals: LA fix-and-flips $400K–$900K with assignable contracts, Sacramento ADU-conversion plays, and Bakersfield cashflow rentals at 1%+ rent-to-price. We supply California’s most active wholesale buyer list.',
    counties: ['Los Angeles', 'Sacramento', 'Kern', 'San Bernardino', 'Riverside', 'Fresno'],
    stats: [
      { label: 'Avg SFR price (LA)', value: '$850K' },
      { label: 'Avg SFR price (Bakersfield)', value: '$340K' },
      { label: 'Avg flip profit (LA County)', value: '$95K' },
      { label: 'Counties served', value: '6+' },
    ],
    keywords: 'we buy houses california, california wholesale properties, california cash home buyers, sell my house fast california, los angeles wholesale, sacramento wholesale, bakersfield wholesale, ca real estate investors, probate california',
    geo: { lat: 36.7783, lon: -119.4179 },
  },
];

export const getStateBySlug = (slug) => states.find((s) => s.slug === slug);
